import axios from './../http'

function add(data) {
    return axios.post('/sys/role/add', data);
}

function del(data) {
    return axios.post('/sys/role/del', data);
}

function update(data) {
    return axios.post('/sys/role/update', data);
}

function query(data) {
    return axios.post('/sys/role/query', data);
}

function get(id) {
    return axios.get('/sys/role/get?id=' + id);
}

function findByUserType(type) {
    return axios.get('/sys/role/findByUserType?type='+type);
}
function valid(data) {
    return axios.post('/sys/role/valid', data);
}
function invalid(data) {
    return axios.post('/sys/role/invalid' , data);
}


export default {
    add,
    del,
    update,
    query,
    get,
    valid,
    invalid,
    findByUserType
}